import myrealestate from "../assets/img/myrealestate.png" ;
import mycars from "../assets/img/mycars.png" ;
import ormado from "../assets/img/ormado.png" ;
import marketinq from "../assets/img/marketinq.png" ;
import garage from "../assets/img/garage.png" ;
import texnoimperiya from "../assets/img/texnoimperiya.png" ;
import xor from "../assets/img/xor.png"
import vertu from "../assets/img/vertu.png" ;
import myperfume from "../assets/img/myperfume.png"
import scheffer from "../assets/img/scheffer.png" ;
import mynumber from "../assets/img/mynumber.png" ;

import appleazerbaijan from "../assets/img/appleazerbaijan.png" ;
import zicoil from "../assets/img/zicoil.png" ;
import myshopsaz from "../assets/img/myshopsaz.png" ;

 const portfolio = [
    {
    id:0,
    title:"My Shops",
    img:myshopsaz,
    link:"https://myshops.az/",
    desc:"MyShops Azərbaycanda mobil və elektron avadanlıqların satışı üzrə liderlərdən biridir. Şirkətimizin təklif etdiyi məhsulların keyfiyyəti yüksək, qiymətləri isə münasibdir.",
  },
    {
    id:1,
    title:"Zicoil",
    img:zicoil,
    link:"https://zicoil.az/",
    desc:"Zicoil.az avtomobiliniz üçün keyfiyyətli motor yağları və texniki mayeləri rahat və sürətli şəkildə əldə etməyə imkan yaradır. Etibarlı məhsullar, sərfəli qiymətlər və asan sifariş.",
  },
    {
    id:2,
    title:"Apple Azərbaycan",
    img:appleazerbaijan,
    link:"https://appleazerbaijan.az/",
    desc:"AppleAzerbaijan.az sizə orijinal Apple məhsullarını rahat və sürətli şəkildə əldə etmək imkanı yaradır. Sadə addımlarla istədiyiniz məhsulu seçin və sifariş edin.",
  },
  
  {
    id:3,title:"MyNumber",
    img:mynumber,
    link:"https://mynumber.az/",
    desc:"Mynumber.az sizə asan və sürətli imkanlar verir. Addımları təkrarlayaraq istədiyiniz nömrəni asanlıqla əldə edə bilərsiniz.",
  },
  {
    id:4,title:"MyPerfume",
    img:myperfume,
    link:"https://myperfume.az/",
    desc:"MyPerfume MMC ətir, odekolon və ətirlə bağlı məhsulların alqı-satqısı üzrə İxtisaslaşmışdır.",
  },
  {
    id:5,title:"Scheffer pvc",
    img:scheffer,
    link:"https://schefferpvc.az/",
    desc:"Kunststoff Scheffer sistemi, 30 ildən artıqdır ki, fəaliyyət göstərir. Bu müddət ərzində sistem, müasir tikinti sahəsində öz keyfiyyəti və dayanıqlılığı ilə tanınır. Həmçinin, inkişaf və yeniliklər sayəsində müştəri tələblərinə cavab verməyə davam edir.",
  },
  {
    id:6,title:"Ormado Kaffehaus",
    img:ormado,
    link:"https://ormado.de/",
    desc:"Indulge your senses in the heart of Germany as Ormado Kaffeehaus brings you a unique coffee experience at our state-of-the-art roasting house. Nestled in the picturesque landscapes of Germany, our facility is where the magic of coffee roasting comes to life, ensuring every cup tells a story of quality and passion. Our expert roasters, armed with years of experience, carefully select and roast each batch, ensuring that the unique characteristics of every bean are highlighted."
  },
    {
      id:7,title:"Vertu",
      img:vertu,
      link:"https://vertuaz.com/",
      desc:"Azərbaycanda ilk rəsmi Vertu mağazasının açılması keyfiyyət və zərifliyə sadiqlik, eləcə də ölkədə dəbdəbəli və yüksək səviyyəli cihazlar bazarının inkişafında irəliyə doğru addım deməkdir. Bu, həm də onu təsdiqləyir ki, Azərbaycan ağıllı istehlakçıların tələblərinə cavab verməyə çalışan qlobal brendlər üçün getdikcə daha cəlbedici bir məkana çevrilir.Bu mağaza müştərilərin Vertu məhsullarının geniş çeşidini araşdıra, ekspert məsləhətləri ala və brendin statusuna uyğun xidmət səviyyəsini yaşaya biləcəkləri yerdir.",
    },


    {
      id:8,title:"My Real Estate",
      img:myrealestate,
      link:"https://www.myrealestate.az/",
      desc:"My Real Estate MMC sizə Dubayda daşınmaz əmlak almaq üçün ən yaxşı seçim və xidmətləri təklif edir",
    },
    {
      id:9,title:"Xor",
      img:xor,
      link:"https://xor.az/",
      desc:"XOR telefonları lüks və texnologiyanın mükəmməl birləşməsini təklif edir. Titan və sapfir kristal kimi üstün materiallardan əl işi olan hər bir məhdud buraxılışlı telefon zərifliyi Knight's Knot loqosu ilə simvollaşdırılan qabaqcıl məxfilik xüsusiyyətləri ilə birləşdirir. Erqonomik dizaynı və fərdiləşdirmə seçimləri ilə XOR telefonları innovasiya və rəqəmsal dünyadan uzaqlaşma arasında qüsursuz istifadəçi təcrübəsi təklif edir.",
    },
    {
      id:10,title:"My Cars",
      img:mycars,
      link:"https://mycars.ae/",
      desc:"Dubaydan avtomobil sifarişi.Bizdə hər büdcəyə uyğun avtomobillər var !",
    },
    {
      id:11,title:"Marketinq",
      img:marketinq,
      link:"https://marketinq.az/",
      desc: "Əgər siz də yeni bir şirkət qurmağa başlamaq və ya mövcud strategiyanızı gücləndirmək istəyirsinizsə, bizim marketing blogumuz tam sizin üçündür! Bu blog, sizə şirkət qurmağa başlayan və ya işinizi yüksək pillələrə daşımaq istəyənlər üçün ən aktual və effektiv marketing strategiyaları haqqında ən son məlumatları təqdim edir.  Bizimlə sizə nələr gözləyir? Şirkət Qurmağa Başlamaq: Əgər hələ yeni bir iş qurmağa hazırlaşmaqdasınızsa, sizin üçün əsas məlumatlar, strateji və keyfiyyətli məsləhətlər təqdim edirik. Bizim təcrübəli mövqe təkəmlərimiz və uğurun sirrləri ilə tanış olun. Strateji Artırmaq: Əgər hal-hazırda fəaliyyət göstərən şirkətinizin strategiyasını inkişaf etdirmək istəyirsinizsə, bizim blog strategiya inkişafı, marketinq planları və müştəri əlaqələrinin gücləndirilməsi kimi ən son məlumatlar və məsləhətlərlə sizi dəstəkləyir.",
    },
    {
      id:12,title:"Garage Academy",
      img:garage,
      link:"https://garage.edu.az/",
      desc:"Peşə sahəsi üzrə kurs (Avtomobil sahəsi).Ali məktəbə daxil olmayan yarı təhsil olan tələbələr üçündür (15-30)"
    },
    {
      id:13,title:"Texno İmperiya",
      img:texnoimperiya,
      link:"https://texnoimperiya.az/",
      desc: "Texno Imperiya MMC” kompüter və kompüter avadanlıqların idxal edən habelə bununla yanaşı servis xidməti göstərən şirkətdir. Siz şirkətimizdən ən uyğun qiymətlərlə yanaşı yüksək keyfiyyətə malik noutbuk, kompüter, monoblok, prosessor, monitor, videokart, ram, ssd və s, məhsulları əldə edə bilərsiniz. Məhsullarımızı istər satış nöqtəmizə yaxınlaşıb istərsə onlayn mağazamızdan sifariş etməklə almağınız mümkündür.",
    }
  ] 

  export default portfolio